/**
 * composable to add EventListeners to our application
 * @param {string} event
 * @param {function} listener
 * @param {boolean} executeOnMounted
 */
export function useWindowEventListener(
  event: string,
  listener: (...args) => void,
  executeOnMounted?: boolean,
) {
  onBeforeMount(() => {
    window.addEventListener(event, listener)
  })

  onMounted(() => {
    if (executeOnMounted) listener()
  })

  onBeforeUnmount(() => {
    window.removeEventListener(event, listener)
  })
}

/**
 * composable to activate the lightbox in the images in the article detail
 * the images to be highlighted will be the images inside the article
 * that are wrapped in an a element and have the wp-caption or wp-post class.
 */
export function useImageLightboxEvent() {
  const { $modal } = useNuxtApp()

  /**
   * we listen when the user clicks and validate that the clicked
   * item meets the criteria to activate the lightbox of the image
   */
  useWindowEventListener('click', (_event) => {
    if (
      _event?.target?.localName === 'img' &&
      _event?.target?.parentNode?.localName === 'a'
    ) {
      _event?.preventDefault()
      if (
        _event?.target?.getAttribute('class').includes('wp-post') ||
        (_event?.target?.parentNode?.parentNode?.localName === 'figure' &&
          _event?.target?.parentNode?.parentNode
            ?.getAttribute('class')
            ?.includes('wp-caption'))
      )
        $modal.open('imageLightbox', _event?.target?.getAttribute('src'))
    }

    if (
      _event?.target?.localName === 'a' &&
      _event?.target?.firstElementChild?.localName === 'img'
    ) {
      _event?.preventDefault()
      if (
        _event?.target?.firstElementChild
          ?.getAttribute('class')
          .includes('wp-post')
      ) {
        $modal.open(
          'imageLightbox',
          _event?.target?.firstElementChild?.getAttribute('src'),
        )
      }
    }

    if (_event?.target?.localName === 'img') {
      if (_event?.target) {
        _event.target.style.cursor = 'pointer'
        $modal.open('imageLightbox', _event?.target?.getAttribute('src'))
      }
    }
  })
}

export enum sizesDevice {
  DESKTOP_BIG = 'DesktopBig',
  DESKTOP = 'Desktop',
  DESKTOP_SMALL = 'DesktopSmall',
  TABLET = 'Tablet',
  MOBILE = 'Mobile',
}

export function getSizeDevice(): sizesDevice | null {
  if (window) {
    if (window.innerWidth >= 1536) {
      return sizesDevice.DESKTOP_BIG
    }
    if (window.innerWidth >= 1280 && window.innerWidth < 1536) {
      return sizesDevice.DESKTOP
    }
    if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
      return sizesDevice.DESKTOP_SMALL
    }
    if (window.innerWidth >= 768 && window.innerWidth < 1024) {
      return sizesDevice.TABLET
    }
    if (window.innerWidth < 768) {
      return sizesDevice.MOBILE
    }
  }
  return null
}

export function isSizeMobile() {
  return sizesDevice.MOBILE === getSizeDevice()
}
